import { store } from 'App'

export const getTenantId = () => {
  const state = store.getState()
  const tenantId = state.user?.tenantId
  return tenantId
}
